<template>
  <div>
    <router-link
      :to="{
        name: 'UserDetails',
        query: {
          userId: data.id,
          username: data.email,
          name: `${data.firstName} ${data.lastName}`,
          companyId: $route.query.companyId,
        },
      }"
      class="btn dealers_btn"
      v-if="!$route.query.groupId && !$route.query.companyID"
    >
      {{ $t("text.actionButtons.edit") }}
    </router-link>

    <router-link
      :to="{
        name: 'industrial_admin_user_details',
        query: {
          userId: data.id,
          username: data.email,
          name: `${data.firstName} ${data.lastName}`,
          companyID: $route.query.companyID,
        },
      }"
      class="btn dealers_btn"
      v-if="$route.query.companyID && !$route.query.groupId"
    >
      {{ $t("text.actionButtons.edit") }}
    </router-link>

    <button
      class="btn dealers_btn"
      @click="unmapFromGroup(data)"
      v-if="$route.query.groupId"
    >
      {{ $t("text.clickButtons.unmapFromGroup") }}
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
      branches: null,
    };
  },
  methods: {
    userDetails() {
      this.$router.push({
        name: "UserDetails",
        query: {
          userId: this.data.id,
        },
      });
    },
    unmapFromGroup(data) {
      // console.log("unmap from group");
      this.$eventHub.$emit("unmapFromGroup", data);
    },
  },
};
</script>
